const COLORS = {
  dark: '#182528',
  blue: '#1CAED4',
  gray: '#F2F2F2',
  gray3: '#828282',
  red: '#EB5757',
};

export { COLORS };
